import { render, staticRenderFns } from "./ProductionRule.vue?vue&type=template&id=f4be5e94&scoped=true"
import script from "./ProductionRule.vue?vue&type=script&lang=js"
export * from "./ProductionRule.vue?vue&type=script&lang=js"
import style0 from "./ProductionRule.vue?vue&type=style&index=0&id=f4be5e94&prod&lang=scss&scoped=true"
import style1 from "./ProductionRule.vue?vue&type=style&index=1&id=f4be5e94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be5e94",
  null
  
)

export default component.exports